import React, { useState, useEffect } from "react";
import { InputNumber } from "antd";
import "./style.css";

const ModuleSelectorCards = ({
  options = [],
  onChange,
  title = "Select Module",
  allowSelection = true,
  isPricingModule = false,
  footerLabel = "Monthly Rate",
  showVehicleInput = false,
  vehicleCount,
  onVehicleChange,
  showFooter = true,
  selectedId: controlledSelectedId,
  selectedIds,
  multiple = false,
  headerExtra = null,
  headerSubtitle = null,
  vehicleLabel = "Number of Vehicles *",
  vehicleMin = 1,
  totalText,
}) => {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    setSelectedId(controlledSelectedId || null);
  }, [controlledSelectedId]);

  const handleSelect = (item) => {
    if (item.disabled) return;

    if (!allowSelection) return;

    if (multiple) {
      const current = selectedIds || [];
      const updated = current.includes(item.id)
        ? current.filter((id) => id !== item.id)
        : [...current, item.id];
      onChange?.(updated);
      return;
    }

    if (selectedId === item.id) {
      setSelectedId(null);
      onChange?.(null);
    } else {
      setSelectedId(item.id);
      onChange?.(item);
    }
  };
  return (
    <div className={`module-wrapper ${isPricingModule ? "no-border" : ""}`}>
      {!isPricingModule ? (
        <div className="module-header-row">
          <div className="module-header-text">
            <h2 className="module-title">{title}</h2>
            {headerSubtitle}
          </div>
          {headerExtra}
        </div>
      ) : (
        <>
          {headerExtra}
          {headerSubtitle}
        </>
      )}

      {showVehicleInput && (
        <div className="vehicle-input-section">
          <label className="vehicle-label">{vehicleLabel}</label>
          <div className="vehicle-combined-container">
            <InputNumber
              value={vehicleCount}
              onChange={onVehicleChange}
              min={vehicleMin}
              placeholder="0"
              controls={false}
              className="vehicle-number-input"
              disabled={!allowSelection}
            />

            <div className="vehicle-total-display">
              {totalText !== undefined ? totalText : (() => {
                const activeIds = selectedIds || (selectedId ? [selectedId] : []);
                const base = activeIds.reduce((sum, id) => {
                  const selected = options.find((o) => o.id === id);
                  const price = Number(
                    selected?.price?.toString().replace(/[^0-9.]/g, "") || 0,
                  );
                  return sum + price;
                }, 0);
                const total = base * (vehicleCount || 0);
                return `$${total.toFixed(2)}`;
              })()}
            </div>
          </div>
        </div>
      )}
      <div className="card-grid">
        {options.map((item) => {
          const isSelected = selectedIds
            ? selectedIds.includes(item.id)
            : selectedId === item.id;

          return (
            <div
              key={item.id}
              className={`card ${isSelected ? "selected" : ""} ${
                item.disabled ? "disabled" : ""
              } ${!allowSelection ? "locked" : ""}`}
              onClick={() => handleSelect(item)}
            >
              <div className="card-body">
                <div>
                  <div className={`checkbox ${isSelected ? "checked" : ""}`}>
                    {isSelected && <span>✓</span>}
                  </div>

                  <div className="icon">{item.icon}</div>

                  <div className="content">
                    <div className="title-row">
                      <h3>{item.title}</h3>
                      {item.tag && <span className="tag">{item.tag}</span>}
                    </div>
                    <p>{item.description}</p>
                  </div>
                </div>

                <div className="line-break"></div>
                {showFooter && item.priceDetails?.length > 0 && (
                  <div className="price-details">
                    {item.priceDetails.map((detail) => (
                      <div className="price-detail" key={detail.label}>
                        <span>{detail.label}</span>
                        <span className="price-detail__value">
                          {detail.value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {showFooter && (
                  <div className="price">
                    <span>{footerLabel}</span>
                    <strong>{item.price}</strong>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleSelectorCards;
